package com.eladfinish.bible.contest.common.gender

import dev.icerock.moko.resources.desc.StringDesc

expect class GenderPersonalizedStringDesc(
    original: StringDesc,
    hebrewGender: HebrewGender,
) : StringDesc

fun StringDesc.personalizeGender(hebrewGender: HebrewGender): StringDesc {
    return GenderPersonalizedStringDesc(this, hebrewGender)
}
